module.exports = __webpack_public_path__ + "static/img/at0.eceb6cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/at0.jpg
// module id = K7+0
// module chunks = 1